<template>
  <section id="iphone-fold" class="fold-section">
    <div class="fold-container">
      <!-- Title & Tagline Header -->
      <div class="fold-header">
        <h2 class="fold-title">{{ t.iphoneFold.title }}</h2>
        <p class="fold-tagline">{{ t.iphoneFold.tagline }}</p>
        <p class="fold-availability">{{ t.iphoneFold.availability }}</p>

        <div class="fold-actions">
          <router-link to="/form" class="btn-action btn-primary">
            {{ t.iphoneFold.learnMore }}
          </router-link>
          <router-link to="/form" class="btn-action btn-secondary">
            {{ t.iphoneFold.buy }}
          </router-link>
        </div>
      </div>

      <!-- Main Visual Showcase -->
      <div class="fold-visual-wrapper">
        <img
          src="@/assets/iphone-fold-hero.png"
          alt="iPhone Fold with expansive folding display"
          class="fold-hero-img"
          loading="lazy"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { useI18n } from '@/i18n';

export default {
  name: 'IPhoneFoldSection',
  setup() {
    const { t } = useI18n();
    return { t };
  }
}
</script>

<style scoped>
.fold-section {
  width: 100%;
  background: #ededf0;
  color: #1d1d1f;
  padding-top: 28px;
  padding-bottom: 0;
  overflow: hidden;
  margin-top: 5px;
  text-align: center;
  position: relative;
}

.fold-container {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fold-header {
  margin-bottom: 10px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fold-title {
  font-size: clamp(32px, 4.2vw, 48px);
  font-weight: 600;
  letter-spacing: -0.015em;
  line-height: 1.08;
  color: #1d1d1f;
  margin: 0 0 4px 0;
  font-family: var(--apple-font);
}

.fold-tagline {
  font-size: clamp(18px, 2.2vw, 22px);
  font-weight: 400;
  letter-spacing: -0.01em;
  color: #1d1d1f;
  margin: 0 0 2px 0;
}

.fold-availability {
  font-size: clamp(13px, 1.4vw, 15px);
  color: #6e6e73;
  font-weight: 400;
  margin: 0 0 14px 0;
}

.fold-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 18px;
  border-radius: 980px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.btn-primary {
  background: #0071e3;
  color: #ffffff;
}

.btn-primary:hover {
  background: #0077ed;
  transform: scale(1.02);
  color: #ffffff;
}

.btn-secondary {
  background: transparent;
  color: #0071e3;
  border: 1px solid #0071e3;
}

.btn-secondary:hover {
  background: #0071e3;
  color: #ffffff;
}

/* Visual Wrapper */
.fold-visual-wrapper {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.fold-hero-img {
  width: 100%;
  height: auto;
  max-width: 1100px;
  display: block;
  object-fit: contain;
  user-select: none;
  mix-blend-mode: multiply;
}

@media (max-width: 768px) {
  .fold-section {
    padding-top: 24px;
    border-top: 8px solid #ffffff;
    border-bottom: 8px solid #ffffff;
  }
  
  .fold-title {
    font-size: 28px;
  }
  
  .fold-tagline {
    font-size: 16px;
  }
  
  .fold-availability {
    font-size: 13px;
    margin-bottom: 12px;
  }
  
  .fold-hero-img {
    max-width: 100%;
    max-height: 260px;
  }
}
</style>
